<button
	type="button"
	class="list-csv-export-button"
	[matTooltip]="tooltip()"
	[disabled]="disabled()"
	(click)="downloadClicked.emit()"
>
	<mat-icon>download</mat-icon>
	<span>{{ label() }}</span>
</button>
